import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable()
export class baseService {

  constructor(private http: HttpClient, private router: Router) { }

  private formatErrors(error: any) {
    //this.router.navigate(['']);
    // check for 401 and redirect to login

    if (error.status === 401) {
      if (error.error === 'Unauthorized access - Trial license expired!') {
        alert('Trial license expired!');
      }
      this.router.navigate(['']);
    }

    var errorJson = JSON.stringify(error);
    console.log(`Error Status: ${error.status}`);
    console.log(JSON.stringify(error));

    return throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${environment.httpBaseUrl}${path}`, { params })
      .pipe(catchError((e: HttpErrorResponse) => this.formatErrors(e)));
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.httpBaseUrl}${path}`,
      JSON.stringify(body)
    ).pipe(catchError((e: HttpErrorResponse) => this.formatErrors(e)));
  }

  patch(path: string, body: Object = {}): Observable<any> {
    return this.http.patch(
      `${environment.httpBaseUrl}${path}`,
      JSON.stringify(body)
    ).pipe(catchError((e: HttpErrorResponse) => this.formatErrors(e)));
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.httpBaseUrl}${path}`,
      JSON.stringify(body)
    ).pipe(catchError((e: HttpErrorResponse) => this.formatErrors(e)));
  }

  delete(path: string): Observable<any> {
    return this.http.delete(
      `${environment.httpBaseUrl}${path}`
    ).pipe(catchError((e: HttpErrorResponse) => this.formatErrors(e)));
  }
}
